/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export * from '../../editor/editor.api.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/basic-languages/fillers/monaco-editor-core.js
// module id = q+RB
// module chunks = 42